import LastScrollCTA from "@components/StrapiComponents/LastScrollCTA";
import ContentWrapper from "@components/common/Base/ContentWrapper";
import Layout from "@components/common/Layout";
import FactBlock from "@components/webinar/FactBlock";
import WebinarHero from "@components/webinar/Hero";
import RelatedWebinars from "@components/webinar/RelatedWebinars";
import WebinarPoints from "@components/webinar/WebinarPoints";
import { FactBlockResponseModel } from "@models/strapi-components/fact-block";
import { LastScrollCTADynamicZoneModel } from "@models/strapi-components/last-scroll-cta";
import { AuthorResponseModel } from "@models/users";
import { RelatedWebinarDataModel, WebinarPointsModel } from "@models/webinar";
import { PageProps, graphql } from "gatsby";
import React from "react";

export interface WebinarPageDataModel {
  strapiWebinar: {
    id: string;
    title: string;
    lastScrollCTA: LastScrollCTADynamicZoneModel;
    factBlock: FactBlockResponseModel;
    author: AuthorResponseModel[];
    webinarPoints: WebinarPointsModel;
    relatedWebinars: RelatedWebinarDataModel;
  };
}

const WebinarPage = (props: PageProps<WebinarPageDataModel>) => {
  const { path, data } = props ?? {};
  const {
    lastScrollCTA,
    title,
    factBlock,
    author,
    webinarPoints,
    relatedWebinars,
  } = data?.strapiWebinar ?? {};
  return (
    <Layout>
      <div>
        <WebinarHero
          bigHeader={title}
          ctaLink={lastScrollCTA?.ctaLink}
          path={path}
        />
        <FactBlock componentData={factBlock} />
        <ContentWrapper>
          <WebinarPoints authors={author} webinarPointsData={webinarPoints} />
        </ContentWrapper>
        <LastScrollCTA componentData={lastScrollCTA} />
        <RelatedWebinars componentData={relatedWebinars} />
      </div>
    </Layout>
  );
};
export default WebinarPage;

export const query = graphql`
  query strapiWebinar($slug: String) {
    strapiWebinar(slug: { eq: $slug }) {
      id
      slug
      lastScrollCTA {
        id
        innerHtml
        ctaText
        ctaLink
        variant
      }
      title
      author {
        firstName
        lastName
        subTitle
        about
      }
      factBlock {
        bgColor
        title
        subTitle
        statTwoTitle
        statTwoDescription
        statOneTitle
        statOneDescription
      }
      author {
        ...author
      }
      webinarPoints {
        id
        title
        points {
          id
          title
          subTitle
          icon
        }
      }
      relatedWebinars {
        title
        webinars {
          title
          learnMoreText
          learnMoreLink
          id
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 307, quality: 100)
              }
            }
          }
        }
      }
    }
  }
`;
